var map = {
	"./1_1_jill_cress.mp3": "FTry",
	"./1_2_richard_edelmen.mp3": "5G4n",
	"./1_3_maya_draisin.mp3": "3bmJ",
	"./2_1_sharmilan_rayer.mp3": "imW0",
	"./2_2_graceann_bennett.mp3": "PtMZ",
	"./2_3_jill_cress.mp3": "b/dn",
	"./2_4_brian_benedik.mp3": "vGp6",
	"./2_5_maya_draisin.mp3": "YDnA",
	"./3_1_maya_draisin.mp3": "hXTs",
	"./3_2_karthic_bala.mp3": "2Yuw",
	"./3_3_jill_cress.mp3": "oW66",
	"./3_4_graceann_bennett.mp3": "gR0T",
	"./3_5_aubrey_flynn.mp3": "j8nd",
	"./4_1_richard_edelman.mp3": "Cnk0",
	"./4_2_maya_draisin.mp3": "7c/P",
	"./4_3_aubrey_flynn.mp3": "Ytbf",
	"./5_1_karthic_bala.mp3": "Fcp3",
	"./5_2_brian_benedik.mp3": "tisR",
	"./5_3_graceann_bennett.mp3": "iZoz",
	"./5_4_kelly_andreson.mp3": "z84b"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sX5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio ^\.\/.*$
// module id = sX5c
// module chunks = 1